/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Basetheme = {
        // All pages
        'common': {
            init: function() {
                // JavaScript to be fired on all pages
            },
            finalize: function() {
                // JavaScript to be fired on all pages, after page specific JS is fired

                $('.navbar').on('shown.bs.collapse', function () {
                    $('body').addClass('fullh');
                });

                $('.navbar').on('hide.bs.collapse', function () {
                    $('body').removeClass('fullh');
                });

                // responsiveVideos(); // init fix for making video embeds more responsive
                // sortPeople(); // init people sorting, filter etc

                // action on pressing the search button on the header nav
                $('#search-btn').on("click", function(e){
                    $(".banner").addClass("active-sok");
                    $("body").css("position", "fixed");
                });

                // action on pressing the cross button on the header nav
                $('#close-btn').on("click", function(e){
                    $(".banner").removeClass("active-sok");
                    $("body").css("position","initial");
                });

                // action on pressing the meny button on the header nav
                $('.navbar-toggler').on("click", function(e){
                    $(".banner").toggleClass("active-meny change");
                    $("html").toggleClass("overflow-hidden");
                });

                $(document).on('keydown', function (e) {
                    if (e.keyCode === 27) { // ESC
                        var $header = $(".banner");
                        if ($header.hasClass('active-sok')) {
                            $('#close-btn').trigger('click');
                        }
                        if ($header.hasClass('active-meny')) {
                            $('.navbar-toggler').trigger('click');
                        }
                    }
                });

                // load more posts ajax call for default archive
                $("#moredefault").on("click", function(e) {

                    var $button = $(this),
                        $buttonspan = $("span", this),
                        catid = '';

                    $buttonspan.html("Laster inn...");
                    $button.addClass("rotate");

                    if (!StarAjax.current_page) {
                        StarAjax.current_page = 1;
                    }

                    if ($('#maxpages').length > 0) {

                        if ($('#maxpages').attr('data-curpage') !== '') {
                            var curpage = $('#maxpages').attr('data-curpage');
                            StarAjax.current_page = curpage;

                        }

                        if ($('#maxpages').attr('data-pages') !== '') {
                            StarAjax.max_page = $('#maxpages').attr('data-pages');
                        }

                        $('#maxpages').remove();

                    }

                    if ($(this).attr('data-catid')) {
                        catid = $(this).attr('data-catid');
                    }

                    // console.log($(this).attr('data-catid'));
                    // console.log(StarAjax.posts);
                    // console.log(StarAjax.current_page);
                    // console.log(StarAjax.max_page);

                    data = {
                        "action": "loadmore_posts_loop",
                        "query": StarAjax.posts,
                        "page" : StarAjax.current_page,
                        "max_page" : StarAjax.max_page,
                        "cat" : catid
                    };


                    // Load more button for Aktuelt load more
                    if ( !$('body').hasClass('search') ) {
                        $.ajax({
                            url: StarAjax.ajaxurl,
                            data : data,
                            type : "POST",
                            beforeSend : function ( xhr ) {},
                            success : function( data ){

                                if ( data ) {

                                    $buttonspan.html("Last flere");
                                    $button.removeClass("rotate");
                                    $(':focus').blur();

                                    $('.addposts').append(data);

                                    StarAjax.current_page++;

                                    if ( StarAjax.current_page >= StarAjax.max_page ) {
                                        $button.hide();
                                    } else if ($('#lastpage').length > 0) {
                                        $button.hide();
                                    }

                                } else {
                                    $button.hide();
                                }
                            }
                        });
                    }

                    // Load more button for search results
                    else {
                        var $searchVar = [];
                        window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,function (a, name, value) {
                                $searchVar = value;
                            });
                        //console.log(StarAjax);

                        $.ajax({
                            type: "POST",
                            url: StarAjax.ajaxurl,
                            data: {
                                action: 'load_more_search_results', // the name of the function in functions.php,
                                s: $searchVar, // the value from the input
                                // paged: 2, // set the page to get the ajax request
                                // posts_per_page: 8,  //number of post to get (use 1 for testing)

                                query: StarAjax.posts,
                                page : StarAjax.current_page,
                                max_page : StarAjax.max_page,
                            },
                            beforeSend: function (xhr) {
                            },
                            success: function (data) {

                                if (data) {

                                    $buttonspan.html("Last flere");
                                    $button.removeClass("rotate");
                                    $(':focus').blur();
                                    $('.ajax-results').append(data);

                                    StarAjax.current_page++;
                                    if (StarAjax.current_page >= StarAjax.max_page) {
                                        $button.hide();
                                    } else if ($('#lastpage').length > 0) {
                                        $button.hide();
                                    }

                                } else {
                                    $button.hide();
                                }
                            }
                        });
                    }
                 });



                // make sure the load more button is hidden on page load
                // in case there are less than 6 posts
                var $total_fp_posts = $('.addposts').attr('data-total');

                if ( $total_fp_posts === $('.carticle').length ) {
                    $("#morecustom").hide();
                }

                // load more posts ajax call for frontpage
                $("#morecustom").on("click", function(e) {

                    var $button = $(this),
                        $buttontext = $('span', this),
                        $postcontainer = $('.addposts'),
                        highlighted_posts = '',
                        excluded_posts = '',
                        $hidden_cards_count = $( ".carticle:hidden" ).length,
                        $hidden_elems = [],
                        custom_loop_posts_per_page = 6;

                    $button.addClass("rotate");
                    $buttontext.html("Laster inn...");

                    if (window.matchMedia("(max-width: 767px)").matches) {
                        custom_loop_posts_per_page = 2;
                    } else if (window.matchMedia("(max-width: 991px)").matches) {
                        custom_loop_posts_per_page = 4;
                    }

                    // get initially hidden carticles
                    $('.carticle:hidden').each(function( index ) {
                        $hidden_elems.push(this);
                    });

                    // #hilites gets created if there are more than 4 featured posts and we are on mobile
                    // and have loaded the first two after the initial two and there are still featured
                    // posts to show before rest of the posts get into the mix
                    if ( $('#hilites').length > 0 ) {

                        highlighted_posts = $('#hilites').attr('data-hilites');
                        $('#hilites').remove();

                    // if we are at max on tablet and there are hidden carticles, get those IDs to pass
                    // to ajax and remove the elements
                    } else if (window.matchMedia("(max-width: 991px)").matches && $hidden_cards_count > 0) {

                        $('.carticle:hidden').each(function( index ) {
                            highlighted_posts += $(this).attr('data-id') + ';';
                            $(this).remove();
                        });

                    }

                    // this is to remove the initial class that causes carticles to be hidden onload of
                    // the page on smaller breakpointss
                    $postcontainer.removeClass('cards__loaded');

                    // list the ids of posts that are already visible to exclude from next loaded batch
                    $('.carticle').each(function( index ) {
                        excluded_posts += $(this).attr('data-id') + ';';
                    });

                    // ajax variables
                    var data = {
                        "action": "loadmore_posts_custom",
                        "posts_per_page": custom_loop_posts_per_page,
                        "highlighted_posts": highlighted_posts,
                        "excluded_posts": excluded_posts
                    };

                    $.ajax({
                        url: StarAjax.ajaxurl,
                        data : data,
                        type : "POST",
                        beforeSend : function ( xhr ) {},
                        success : function( data ){

                            if ( data ) {
                                $('.addposts').append(data);

                                $buttontext.html("Last flere");
                                $button.removeClass("rotate");
                                $(':focus').blur();

                                if ( $total_fp_posts === $('.carticle').length ) {
                                    $button.hide();
                                }

                            } else {
                                $button.hide();
                            }
                        }
                    });
                });


                // ajaxified categories
                $(".cat-link").on("click", function(e) {
                    e.preventDefault();

                    var $cat_link = $(this),
                        $cat_id = $(this).attr('data-catid'),
                        $button = $('#moredefault'),
                        $buttonspan = $('span', '#moredefault'),
                        $postcontainer = $('.addposts'),
                        custom_category_loop_page = 1,
                        custom_max_page = 1;

                        $button.attr('data-catid', '');

                        $('#catfilters li').removeClass('current-cat');
                        $('#catfilters li').removeClass('cat-item-all');

                        $(this).parent('li').addClass('current-cat');

                    var data = {
                        "action": "get_category_posts",
                        "catid": $cat_id
                    };

                    $postcontainer.fadeOut();

                    $.ajax({
                        url: StarAjax.ajaxurl,
                        data : data,
                        type : "POST",
                        beforeSend : function ( xhr ) {},
                        success : function( data ){

                            if ( data ) {

                                $postcontainer.html(data);
                                $postcontainer.fadeIn();

                                if ($postcontainer.html().length > 0) {

                                    var custom_max_page = $('#maxpages').attr('data-pages');
                                    var cat_id = $('#maxpages').attr('data-catid');

                                    custom_category_loop_page++;

                                    if ( custom_category_loop_page > custom_max_page ) {
                                        $button.hide();
                                    } else {
                                        $button.attr('data-catid', cat_id);
                                        $button.show();
                                    }

                                } else {
                                    $button.hide();
                                }

                            } else {
                                $button.hide();
                            }
                        }
                    });
                });


                // some js to help with the main menu nav dropdown

                var $navbar = $('#the-nav');

                function toggleDropdown(e) {

                    var _dropdownLi = $(e.target).closest('.dropdown'),
                        _dropdownUl = $('.dropdown-menu', _dropdownLi);

                    setTimeout(function () {
                        var shouldOpen = e.type !== 'click' && _dropdownLi.is(':hover');
                        _dropdownUl.toggleClass('show', shouldOpen);
                        _dropdownLi.toggleClass('show', shouldOpen);
                    }, e.type === 'mouseleave' ? 300 : 0);
                }

                $('body').on('mouseenter mouseleave', '.dropdown', toggleDropdown);

                // make menu keyboard tabbable
                $navbar.on('keyup', function(e) {
                     // 27 == esc, 9 == tab
                    // TODO: tabindex on reverse tabbing...
                    if ( e.type === 'keyup' && e.keyCode === 27 ) {
                        closeAll();
                    } else if ( $(e.target).is('.dropdown-toggle,.dropdown-item') && e.type === 'keyup' && e.keyCode === 9 ) {
                        var togglers = $(e.target).closest('.dropdown')
                            .add( $('.dropdown-menu', $(e.target).closest('.dropdown')) );
                        togglers.addClass('show');
                    } else if ( !$(e.target).is('.dropdown-toggle,.dropdown-item') && e.type === 'keyup') {
                        closeAll();
                    }
                    function closeAll() {
                        $navbar.find('.dropdown,.dropdown-menu').removeClass('show');
                    }
                });


                // People/menneskene intern filtering etc.
                // function sortPeople() {
                //     if ( !localStorage.getItem('peopleSort') ) {
                //         localStorage.setItem('peopleSort', 'cards');
                //     }

                //     var $peopleList = $('#people-list'); // main people list wrapper

                //     setPeoplelistFilter( localStorage.getItem('peopleSort') );
                //     $('#loading-wrapper').delay(1000).fadeOut(300, function (){
                //         $peopleList.addClass('show');
                //     });

                //     $('.people-sortby ').on('click', function () {
                //         setPeoplelistFilter( $(this).data('sortby') );
                //     });

                //     function setPeoplelistFilter(sortby) {
                //         $peopleList.removeClass('sort-like-cards sort-like-list');
                //         $peopleList.addClass('sort-like-' + sortby);
                //         localStorage.setItem('peopleSort',  sortby);

                //         if (sortby === 'list') {
                //             $peopleList.find('tr:visible').each(function(i, val) {
                //                 $(val).css('opacity', '0').delay(i * 30).animate({
                //                     opacity: 1
                //                 }, 120);
                //             });

                //         } else {
                //             $peopleList.find('.people__person:visible').each(function(i, val) {
                //                 $(val).css('opacity', '0').delay(i * 50).animate({
                //                     opacity: 1
                //                 }, 150);
                //             });
                //         }
                //    }

                //     // Searched/filter submit
                //     $('#people-filter').on('submit', function (e) {
                //         e.preventDefault();

                //         var searchText = $('#people-search').val().toLowerCase().trim();

                //         // table/list view firstly:
                //         var $tds = $peopleList.find('td');
                //         $tds.parent('tr').fadeOut(100);
                //         var selectFilterStr = $('select#filter').val().toLowerCase(); // default 'all'

                //         if (selectFilterStr !== 'all') {
                //             $('.company-list').fadeOut(200);
                //             $('.company-list[data-company=' + selectFilterStr + ']').delay(200).fadeIn(300);
                //         } else {
                //             $('.company-list').fadeIn(300);
                //         }

                //         $tds.each(function(i, val) {
                //             var txt = $(this).text().toLowerCase().trim();
                //             var not_found = (txt.indexOf(searchText) <= -1);
                //             if (!not_found) {
                //                 $(this).closest('tr').fadeIn(200);
                //             }
                //         });

                //         // then the cards view
                //         $peopleList.find('.people__person').fadeOut(100);
                //         $peopleList.find('.people__person--details').each(function () {
                //             var txt = $(this).text().toLowerCase().trim();
                //             var not_found = (txt.indexOf(searchText) <= -1);
                //             if (selectFilterStr !== 'all' && !not_found) {
                //                 var thisCompany = $(this).find('.company').text().toLowerCase();
                //                 not_found = thisCompany != selectFilterStr;
                //             }
                //             if (!not_found) {
                //                 $(this).closest('.people__person').fadeIn(200);
                //             }
                //         });
                //     });

                //     $('.company-list table').each(function(i, element) {
                //         var table = $(element);
                //         $('th', table).each(function(i, th) {
                //             $(th).on('click', function () {
                //                 $(this).toggleClass('sort-active');
                //                 $(this).siblings('th').removeClass('sort-active');
                //                 this.tableID = '#' + $(table).attr('id');
                //                 w3.sortHTML(this.tableID, '.sortable-rows', "td:nth-child(" + (i + 1) + ")");
                //             });
                //         });
                //     });
                // }
                // end of sortPeople stuff


                // custom dropdown styles for the forms
                // todo: optimize code for custom select
                // function closeAllSelect(elmnt) {
                //     /* A function that will close all select boxes in the document,
                //     except the current select box: */
                //     var selItems, selSelected, i, arrNo = [];
                //     selItems = document.getElementsByClassName("select-items");
                //     selSelected = document.getElementsByClassName("select-selected");
                //     for (i = 0; i < selSelected.length; i++) {
                //         if (elmnt === selSelected[i]) {
                //             arrNo.push(i);
                //         } else {
                //             selSelected[i].classList.remove("select-arrow-active");
                //         }
                //     }
                //     for (i = 0; i < selItems.length; i++) {
                //         if (arrNo.indexOf(i)) {
                //             selItems[i].classList.add("select-hide");
                //         }
                //     }
                // }

                var selWrap, i, j, selElmnt, a, b, c;
                /* Look for any elements with the class "styleselect": */
                selWrap = document.getElementsByClassName("styleselect");

                if (selWrap.length > 0) {

                    // var origSel = document.getElementsByClassName("wpcf7-select")[0];
                    // origSel.style.display = 'none';
                    for (i = 0; i < selWrap.length; i++) {

                      selElmnt = selWrap[i].getElementsByTagName("select")[0];
                      selElmnt.style.display = 'none';
                      /* For each element, create a new DIV that will act as the selected item: */
                      a = document.createElement("DIV");
                      a.setAttribute("class", "select-selected");
                      a.setAttribute("tabindex", "0");
                      a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
                      // console.log(a.innerHTML);
                      selWrap[i].appendChild(a);
                      /* For each element, create a new DIV that will contain the option list: */
                      b = document.createElement("DIV");
                      b.setAttribute("class", "select-items select-hide");

                      for (j = 0; j < selElmnt.length; j++) {

                        /* For each option in the original select element,
                        create a new DIV that will act as an option item: */
                        c = document.createElement("DIV");
                        c.innerHTML = selElmnt.options[j].innerHTML;
                        c.setAttribute("tabindex", "0");
                        if (c.innerHTML === selElmnt.options[0].innerHTML) {
                            c.setAttribute("class", "same-as-selected");
                        }

                        c.addEventListener('click', function(e) {

                            /* When an item is clicked, update the original select box,
                            and the selected item: */
                            var y, i, k, s, h;
                            s = this.parentNode.parentNode.getElementsByClassName("wpcf7-select")[0];
                            h = this.parentNode.previousSibling;
                            for (i = 0; i < s.length; i++) {
                              if (s.options[i].innerHTML === this.innerHTML) {
                                s.selectedIndex = i;
                                h.innerHTML = this.innerHTML;
                                y = this.parentNode.getElementsByClassName("same-as-selected");
                                for (k = 0; k < y.length; k++) {
                                  y[k].removeAttribute("class");
                                }
                                this.setAttribute("class", "same-as-selected");
                                break;
                              }
                            }
                            h.click();

                        });

                        c.addEventListener('keyup', function(e) {

                            if (e.keyCode === 13 || e.keyCode === 'Enter' || e.keyCode === 32 || e.keyCode === 'Space') {

                                /* When an item is clicked, update the original select box,
                                and the selected item: */
                                var y, i, k, s, h;
                                s = this.parentNode.parentNode.getElementsByClassName("wpcf7-select")[0];
                                h = this.parentNode.previousSibling;
                                for (i = 0; i < s.length; i++) {
                                  if (s.options[i].innerHTML === this.innerHTML) {
                                    s.selectedIndex = i;
                                    h.innerHTML = this.innerHTML;
                                    y = this.parentNode.getElementsByClassName("same-as-selected");
                                    for (k = 0; k < y.length; k++) {
                                      y[k].removeAttribute("class");
                                    }
                                    this.setAttribute("class", "same-as-selected");
                                    break;
                                  }
                                }
                                h.click();

                            }
                        });

                        b.appendChild(c);

                      }

                      selWrap[i].appendChild(b);

                      a.addEventListener("click", function(e) {
                        /* When the select box is clicked, close any other select boxes,
                        and open/close the current select box: */
                        e.stopPropagation();
                        closeAllSelect(this);
                        this.nextSibling.classList.toggle("select-hide");
                        this.classList.toggle("select-arrow-active");
                      });

                      a.addEventListener("keyup", function(e) {
                        if (e.keyCode === 13 || e.keyCode === 'Enter' || e.keyCode === 32 || e.keyCode === 'Space') {
                            /* When the select box is clicked, close any other select boxes,
                            and open/close the current select box: */
                            e.stopPropagation();
                            closeAllSelect(this);
                            this.nextSibling.classList.toggle("select-hide");
                            this.classList.toggle("select-arrow-active");

                        }
                      });
                    }
                    /* If the user clicks anywhere outside the select box,
                    then close all select boxes: */
                    document.addEventListener("click", closeAllSelect);
                }

            }
        },
        // Home page
        'home': {
            init: function() {
                // carousel with data-attrs or by js here?
                var $slider = $('.carousel').carousel({});

                $('#playBtn').on('click', function (e) {
                    $slider.carousel('cycle');
                    $slider.removeClass('paused');
                    $slider.addClass('playing');
                });
                $('#pauseBtn').on('click', function (e) {
                    $slider.carousel('pause');
                    $slider.addClass('paused');
                    $slider.removeClass('playing');
                });
            },
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
              }
            },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function() {
                // JavaScript to be fired on the about us page
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function(func, funcname, args) {
            var fire;
            var namespace = Basetheme;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function() {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);


    // Find all YouTube/vimeo iframe embeds and give them responsive sizing
    // function responsiveVideos() {
    //     var $iframes = $("iframe");

    //     // Figure out and save aspect ratio for each iframe video
    //     $iframes.each(function() {
    //         this.$iframe = $(this);

    //         // if it ain't vimeo or youtube, don't bother
    //         this.src = this.$iframe.attr('src');
    //         if ( this.src.indexOf('vimeo') < 0 && this.src.indexOf('youtube') < 0 ) {
    //             return;
    //         }

    //         // PS, some iframes might not have width/height attributes, so let's use jquery to get the size.
    //         this.height = this.$iframe.height();
    //         this.width = this.$iframe.width();
    //         this.$iframe.data('aspectRatio', this.height / this.width );
    //         // and remove the hard coded width and height
    //         this.$iframe.removeAttr('width height');
    //     });

    //     // Each time the window is resized
    //     $(window).resize(function () {
    //         requestAnimationFrame(function () {

    //             // Resize all videos to full width parent container
    //             // keep aspect ratio, thus calculate height.
    //             $iframes.each(function () {
    //                 this.$iframe = $(this);
    //                 this.newWidth = this.$iframe.parent().width();
    //                 this.newHeight = this.newWidth * this.$iframe.data('aspectRatio');
    //                 this.$iframe
    //                     .width(this.newWidth)
    //                     .height(this.newHeight);
    //             });
    //         });
    //     }).resize(); // Kick off one resize to fix all videos on page load!
    // } // responsiveVideos


})(jQuery); // Fully reference jQuery after this point.




/* W3.JS 1.04 April 2019 by w3schools.com */
"use strict";
var w3 = {};
w3.getElements = function (id) {
  if (typeof id == "object") {
    return [id];
  } else {
    return document.querySelectorAll(id);
  }
};
w3.sortHTML = function(id, sel, sortvalue) {
    var table, b, i, ii, y, bytt, v1, v2, cc, j;
    table = w3.getElements(id);

    for (i = 0; i < table.length; i++) {
        for (j = 0; j < 2; j++) {
            cc = 0;
            y = 1;

            // $(table).find('th').removeClass('sort-active');

            while (y == 1) {
                y = 0;

                b = table[i].querySelectorAll(sel);
                for (ii = 0; ii < (b.length - 1); ii++) {
                    bytt = 0;
                    if (sortvalue) {
                        v1 = b[ii].querySelector(sortvalue).innerText;
                        v2 = b[ii + 1].querySelector(sortvalue).innerText;
                    } else {
                        v1 = b[ii].innerText;
                        v2 = b[ii + 1].innerText;
                    }
                    v1 = v1.toLowerCase();
                    v2 = v2.toLowerCase();
                    if ((j == 0 && (v1 > v2)) || (j == 1 && (v1 < v2))) {
                        bytt = 1;
                        break;
                    }
                }
                if (bytt == 1) {
                    b[ii].parentNode.insertBefore(b[ii + 1], b[ii]);
                    y = 1;
                    cc++;
                }
            }
            if (cc > 0) {break;}
        }
    }
};
w3.getElementsByAttribute = function (x, att) {
  var arr = [], arrCount = -1, i, l, y = x.getElementsByTagName("*"), z = att.toUpperCase();
  l = y.length;
  for (i = -1; i < l; i += 1) {
    if (i == -1) {y[i] = x;}
    if (y[i].getAttribute(z) !== null) {arrCount += 1; arr[arrCount] = y[i];}
  }
  return arr;
};
